import Page from "webPage/Page";
import {handleAccordions} from "util/accordions";

Page.register("page-template-faqs", () => {
    handleAccordions();
});